export const themeLight = {
    backgroundColor: '#fff',
    fontColor: '#1e88e5',
    toggleBackgroundColor: '#1e88e5',
    toggleForegroundColor: '#fff',
    iconColor: '#000',
    borderColor: '#ccc'
  };
  
  export const themeDark = {
    backgroundColor: '#37474f',
    fontColor: '#2196f3',
    toggleBackgroundColor: '#2196f3',
    toggleForegroundColor: '#fff',
    iconColor: '#fff',
    borderColor: '#3282b8'
  };

  export const THEME_LIGHT = 'light';
  export const THEME_DARK = 'dark';